import type { PaletteOptions } from '@mui/material';

// Scrollbar treatments expressed as the `body` styleOverride for MuiCssBaseline.
// Pure functions of palette so they adapt to each resolved theme's neutral ramp.

const SCROLLBAR_TRACK_SELECTOR = '&::-webkit-scrollbar, & *::-webkit-scrollbar';

export const defaultScrollbar = (palette: PaletteOptions, restingThumbColor = palette.neutral?.[300]) => ({
  [SCROLLBAR_TRACK_SELECTOR]: {
    display: 'block',
    '@media (max-width: 899.95px)': {
      display: 'none',
    },
    backgroundColor: 'transparent',
    width: 8,
    height: 8,
    border: '1px solid',
    borderColor: palette.neutral?.[800],
  },
  '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
    borderRadius: 8,
    backgroundColor: restingThumbColor,
    backgroundClip: 'padding-box',
    border: '2px solid transparent',
    minHeight: 24,
  },
  '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
    backgroundColor: restingThumbColor,
  },
  '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
    backgroundColor: restingThumbColor,
  },
  '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
    backgroundColor: palette.neutral?.[300],
  },
});

export const borderlessScrollbar = (palette: PaletteOptions) => {
  const styles = defaultScrollbar(palette, palette.neutral?.[400]);
  const firefoxScrollbar = {
    scrollbarColor: `${palette.neutral?.[400]} transparent`,
    scrollbarWidth: 'thin',
    '@media (max-width: 899.95px)': { scrollbarWidth: 'none' },
  };

  return {
    ...styles,
    // Keep standard scrollbar properties in Firefox so Chromium retains the thumb-only hover color.
    '@supports (-moz-appearance: none)': {
      ...firefoxScrollbar,
      '& *': firefoxScrollbar,
    },
    [SCROLLBAR_TRACK_SELECTOR]: {
      ...styles[SCROLLBAR_TRACK_SELECTOR],
      border: 'none',
    },
  };
};

export const thinScrollbar = (palette: PaletteOptions) => ({
  '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
    display: 'block',
    '@media (max-width: 899.95px)': {
      display: 'none',
    },
    backgroundColor: 'transparent',
    width: 6,
    height: 6,
  },
  '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
    borderRadius: 8,
    backgroundColor: palette.neutral?.[300],
    backgroundClip: 'padding-box',
    border: '1px solid transparent',
    minHeight: 24,
  },
  '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
    backgroundColor: palette.neutral?.[300],
  },
  '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
    backgroundColor: palette.neutral?.[300],
  },
  '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
    backgroundColor: palette.neutral?.[300],
  },
});
